import { IDirectDealFilter, IDirectDealFilterOption } from '../../constants/filter/directDealFilter.constant';
import { DirectDealSliderFilterKeyType } from '../../constants/filter/slider/directDealFilterSliderConstant';
import { getDirectDealSliderValue } from './directDealSliderValue.util';

interface ICreateDirectDealFilterSearchParamsParam {
  filters: IDirectDealFilter[];
}

// 범위 조건은 '제한 없음'이면 키 자체를 넣지 않는다.
interface ICreateDirectDealFilterSearchParamsReturn {
  brand?: string;
  minEngineOutputPs?: number;
  maxEngineOutputPs?: number;
  minPrice?: number;
  maxPrice?: number;
  minManufacturedYear?: number;
  maxManufacturedYear?: number;
  sort: string;
  count: number;
  page: number;
  status: string;
  machineType: string;
  rowConfig: string;
  minOperationTime?: number;
  maxOperationTime?: number;
  recentDays?: number;
  region?: string;
}

export const createDirectDealFilterSearchParams = ({
  filters,
}: ICreateDirectDealFilterSearchParamsParam): ICreateDirectDealFilterSearchParamsReturn => {
  const getFilterOptionValues = (filterKey: string) =>
    filters
      .find((filter) => filter.key === filterKey)
      ?.options.filter((option: IDirectDealFilterOption) => option.isSelected)
      .map((option: IDirectDealFilterOption) => option.value)
      .join(',');

  const getSliderRange = (filterKey: DirectDealSliderFilterKeyType) => {
    const options = filters.find((filter) => filter.key === filterKey)?.options;

    return {
      min: getDirectDealSliderValue(filterKey, Number(options?.find((option) => option.optionName === 'min')?.value)),
      max: getDirectDealSliderValue(filterKey, Number(options?.find((option) => option.optionName === 'max')?.value)),
    };
  };

  const sorterFilterOptionValues = getFilterOptionValues('sorter');
  const brandFilterOptionValues = getFilterOptionValues('filter_brand');
  const statusFilterOptionValues = getFilterOptionValues('status');
  const machineTypeFilterOptionValues = getFilterOptionValues('machineType');
  const rowConfigFilterOptionValues = getFilterOptionValues('rowConfig');
  const recentDaysFilterOptionValues = getFilterOptionValues('recentDays');
  const regionFilterOptionValues = getFilterOptionValues('region');

  const engineOutputPsRange = getSliderRange('engineOutputInPs');
  const priceRange = getSliderRange('price');
  const manufacturedYearRange = getSliderRange('manufacturedYear');
  const operationTimeRange = getSliderRange('operationTime');

  return {
    brand: brandFilterOptionValues ?? undefined,
    ...(engineOutputPsRange.min !== undefined && { minEngineOutputPs: engineOutputPsRange.min }),
    ...(engineOutputPsRange.max !== undefined && { maxEngineOutputPs: engineOutputPsRange.max }),
    ...(priceRange.min !== undefined && { minPrice: priceRange.min }),
    ...(priceRange.max !== undefined && { maxPrice: priceRange.max }),
    ...(manufacturedYearRange.min !== undefined && { minManufacturedYear: manufacturedYearRange.min }),
    ...(manufacturedYearRange.max !== undefined && { maxManufacturedYear: manufacturedYearRange.max }),
    sort: sorterFilterOptionValues ?? 'default_desc',
    count: 10,
    page: 1,
    status: statusFilterOptionValues ?? '',
    machineType: machineTypeFilterOptionValues ?? '',
    rowConfig: rowConfigFilterOptionValues ?? '',
    ...(operationTimeRange.min !== undefined && { minOperationTime: operationTimeRange.min }),
    ...(operationTimeRange.max !== undefined && { maxOperationTime: operationTimeRange.max }),
    ...(recentDaysFilterOptionValues && { recentDays: Number(recentDaysFilterOptionValues) }),
    ...(regionFilterOptionValues && { region: regionFilterOptionValues }),
  };
};
